webpackJsonp([215770557903290],{

/***/ 1766:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DosageCalculationResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"calculatedAmount","type":{"kind":"SCALAR","name":"PlainDecimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"dose","type":{"kind":"SCALAR","name":"PlainDecimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"doseRangeStatus","type":{"kind":"ENUM","name":"DoseRangeStatus","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"patientWeightKg","type":{"kind":"SCALAR","name":"PlainDecimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totalDose","type":{"kind":"SCALAR","name":"PlainDecimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-dosage-calculation-result-38e7bab300250f228eba.js